import React from "react";

// mui components
import { Modal, Stack } from "@mui/material";

// custom components
import PrimaryButton from "../../buttons/primary-button";
import SecondaryButton from "../../buttons/secondary-button";
import Body2 from "../../typography/body-02";

// mui icons
import { WarningAmberOutlined } from "@mui/icons-material";

// custom styles
import styles from "./index.module.scss";

export default function ConfirmationModal({
	open,
	text,
	confirmText,
	handleConfirm,
	closeText,
	handleClose,
}) {
	return (
		<Modal
			open={open}
			aria-labelledby="confirmation modal"
			aria-describedby="confirmation modal"
			disableAutoFocus={true}
			disableEscapeKeyDown={true}
		>
			<Stack
				direction="column"
				justifyContent="center"
				alignItems="center"
				className={styles.modalBodyContainer}
			>
				<WarningAmberOutlined className={styles.iconContainer} />

				<Stack
					direction="column"
					alignItems="center"
					className={styles.textContainer}
				>
					<Body2 text={text} extraClass={styles.confirmationText} />
				</Stack>

				<PrimaryButton
					text={confirmText}
					onClick={handleConfirm}
					fullWidth={true}
				/>

				<SecondaryButton
					text={closeText}
					onClick={handleClose}
					fullWidth={true}
					extraClass={styles.closeBtn}
					extraTextClass={styles.closeBtnText}
				/>
			</Stack>
		</Modal>
	);
}
